export const administrationAccountsHeadOfficeLicencesState = {
    name: 'app.administration.accounts.headOfficesLicences',
    url: '/licences?hof',
    component: 'administrationAccountsHeadOfficeLicences'
};